@if (patient && userList() && organisme() !== undefined) {
  <div tuiCardLarge tuiSurface="elevated">
    <div class="row">
      <div class="col col-12">
        <h2>Prescriptions</h2>
        @if (afficherBoutonTemporaire()) {
          @if (codeActiviteService.PPC.includes(activite)) {
            @if (dernierePrescriptionForm("PPC")) {
              <article>
                <div>Dernière prescription signée</div>
                <button
                  type="button"
                  appearance="outline"
                  iconStart="@tui.download"
                  size="s"
                  tuiButton
                  (click)="openPdf(actions, dernierePrescriptionForm('PPC')!)"
                >
                  Télécharger
                </button>
              </article>
            }
          } @else if (codeActiviteService.VENTILATION.includes(activite)) {
            @if (dernierePrescriptionForm("VENTILATION")) {
              <article>
                <div>Dernière prescription signée</div>
                <button
                  type="button"
                  appearance="outline"
                  iconStart="@tui.download"
                  size="s"
                  tuiButton
                  (click)="
                    openPdf(actions, dernierePrescriptionForm('VENTILATION')!)
                  "
                >
                  Télécharger
                </button>
              </article>
            }
          } @else if (codeActiviteService.O2.includes(activite)) {
            @if (dernierePrescriptionForm("O2")) {
              <article>
                <div>Dernière prescription signée</div>
                <button
                  type="button"
                  appearance="outline"
                  iconStart="@tui.download"
                  size="s"
                  tuiButton
                  (click)="openPdf(actions, dernierePrescriptionForm('O2')!)"
                >
                  Télécharger
                </button>
              </article>
            }
          } @else if (
            codeActiviteService.FORFAITS_ASSOCIES_PPC.includes(activite)
          ) {
            @if (dernierePrescriptionForm("PPC")) {
              <article>
                <div>Dernière prescription PPC signée</div>
                <button
                  type="button"
                  appearance="outline"
                  iconStart="@tui.download"
                  size="s"
                  tuiButton
                  (click)="openPdf(actions, dernierePrescriptionForm('PPC')!)"
                >
                  Télécharger
                </button>
              </article>
            }
            @if (dernierePrescriptionForm("O2")) {
              <article>
                <div>Dernière prescription O2 signée</div>
                <button
                  type="button"
                  appearance="outline"
                  iconStart="@tui.download"
                  size="s"
                  tuiButton
                  (click)="openPdf(actions, dernierePrescriptionForm('O2')!)"
                >
                  Télécharger
                </button>
              </article>
            }
          } @else if (
            codeActiviteService.FORFAITS_ASSOCIES_VNI.includes(activite)
          ) {
            @if (dernierePrescriptionForm("O2VNI")) {
              <article>
                <div>Dernière prescription signée</div>
                <button
                  type="button"
                  appearance="outline"
                  iconStart="@tui.download"
                  size="s"
                  tuiButton
                  (click)="openPdf(actions, dernierePrescriptionForm('O2VNI')!)"
                >
                  Télécharger
                </button>
              </article>
            }
          } @else if (codeActiviteService.AVF.includes(activite)) {
            @if (dernierePrescriptionForm("AVF")) {
              <article>
                <div>Dernière prescription signée</div>
                <button
                  type="button"
                  appearance="outline"
                  iconStart="@tui.download"
                  size="s"
                  tuiButton
                  (click)="openPdf(actions, dernierePrescriptionForm('PPC')!)"
                >
                  Télécharger
                </button>
              </article>
            }
          } @else if (codeActiviteService.AEROSOLS.includes(activite)) {
            @if (dernierePrescriptionForm("AEROSOLS")) {
              <article>
                <div>Dernière prescription signée</div>
                <button
                  type="button"
                  appearance="outline"
                  iconStart="@tui.download"
                  size="s"
                  tuiButton
                  (click)="
                    openPdf(actions, dernierePrescriptionForm('AEROSOLS')!)
                  "
                >
                  Télécharger
                </button>
              </article>
            }
          }
        }

        @for (
          prescription of patient.prescriptionList?.data;
          track prescription.id
        ) {
          @if ((!prescription.dateRetour || prescription.prescriptionForm) && !prescription.read_only) {
            <app-prescription-row
              [prescription]="prescription"
              [patient]="patient"
              [userList]="userList()"
              [prescriptionFormList]="prescriptionFormList()"
              [organisme]="organisme()"
              [activite]="activite"
              (formCompleted)="onFormCompleted()"
            />
          }
        }
      </div>
    </div>
  </div>
} @else {
  <div tuiCardLarge tuiSurface="elevated">
    <div class="row">
      <div class="col col-12">
        <h2>Prescriptions</h2>
        <article>
          <div>Prescription du <span class="placeholder">XX/XX/XXXX</span></div>
          <button
            type="button"
            [disabled]="true"
            appearance="outline"
            iconStart="@tui.download"
            size="s"
            tuiButton
          >
            Télécharger
          </button>
        </article>
        <article>
          <div>Prescription du <span class="placeholder">XX/XX/XXXX</span></div>
          <button
            type="button"
            [disabled]="true"
            appearance="outline"
            iconStart="@tui.download"
            size="s"
            tuiButton
          >
            Télécharger
          </button>
        </article>
        <article>
          <div>Prescription du <span class="placeholder">XX/XX/XXXX</span></div>
          <button
            type="button"
            [disabled]="true"
            iconStart="@tui.pencil"
            size="s"
            tuiButton
          >
            Editer
          </button>
        </article>
      </div>
    </div>
  </div>
}
<ng-template #actions let-content="content">
  <a download size="s" tuiButton [href]="content"> Télécharger </a>
</ng-template>
